import syncApi from '@/data/api/sync';
import usersApi from '@/data/api/users';
import { createWebLocalDatabase } from './dexieLocalDatabase';
import { createSynchronizedEntityReadModel } from './createSynchronizedEntityReadModel';
import { createWebLocalSyncCoordinator } from '@/domain/services/sync/webLocalSyncCoordinator';

/**
 * Creates the local read model for synchronized work intervals.
 *
 * The generic LocalDatabase entity API stays behind this data-layer adapter;
 * consumers receive plain interval records after authoritative server sync.
 *
 * @param {Object} [options] - Data-layer dependencies.
 * @param {Object} [options.database] - LocalDatabase adapter.
 * @param {Object} [options.pullApi] - Sync pull transport adapter.
 * @param {Object} [options.identity] - Authenticated identity provider.
 * @returns {Object} Local work-interval read model.
 */
export const createWorkIntervalLocalReadModel = ({
  database = createWebLocalDatabase(),
  pullApi = syncApi,
  identity = usersApi,
  syncCoordinator = createWebLocalSyncCoordinator({
    database,
    pullApi,
    identity
  })
} = {}) => {
  const readModel = createSynchronizedEntityReadModel({
    entityType: 'work_interval',
    syncCoordinator,
    materialize: (records) => records,
    buildChangeSet: ({ changes, records }) => ({
      changes,
      workIntervals: records
    })
  });

  return {
    ...readModel,
    readLocalWorkIntervals: readModel.readLocalEntities,
    readChangedWorkIntervals: readModel.readChangedEntities
  };
};
